export default defineNuxtRouteMiddleware(async () => {
  const { loggedIn, fetch } = useUserSession()
  await fetch()
  if (!loggedIn.value) {
    const session = useCookie('nuxt-session')
    session.value = null
  }
})
